import {CanDeactivateFn} from '@angular/router';

export interface UnsavedChangesComponent {
  hasUnsavedChanges(): boolean;
  unsavedChangesMessage(): string;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesComponent> = (component) => {
  if (!component.hasUnsavedChanges()) return true;
  return confirm(component.unsavedChangesMessage());
};
